.bf{position:absolute;}